import type { ReactNode } from 'react'
import { Swords } from 'lucide-react'
import { cn } from '@/lib/utils'
import FriendAvatar from './FriendAvatar'

type Props = {
  nickname: string
  handle: string
  avatarUrl?: string
  power?: number
  rank?: number
  highlight?: boolean
  onClick?: () => void
  actions?: ReactNode
}

/** フレンド一覧・FoF・検索・ランキングで使う汎用の1行。 */
export default function FriendRow({
  nickname, handle, avatarUrl, power, rank, highlight, onClick, actions,
}: Props) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 py-2 min-h-[44px]',
        onClick && 'cursor-pointer',
        highlight && 'bg-primary/10 -mx-4 px-4',
      )}
      onClick={onClick}
    >
      {rank != null && (
        <span className="w-6 shrink-0 text-center text-sm font-bold tabular-nums">{rank}</span>
      )}
      <FriendAvatar nickname={nickname} avatarUrl={avatarUrl} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium">{nickname}</p>
        <p className="truncate text-xs text-muted-foreground">@{handle}</p>
      </div>
      {power != null && (
        <span className="flex shrink-0 items-center gap-1 text-sm tabular-nums">
          <Swords size={14} className="text-muted-foreground" />
          {power.toLocaleString()}
        </span>
      )}
      {actions && <div className="shrink-0" onClick={(e) => e.stopPropagation()}>{actions}</div>}
    </div>
  )
}
